import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
/**
 *摄像头图层
 */
class CameraLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.CAMERA;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();

        data.forEach((obj) =>{
            let item={...obj};
            item.layerName=self.layerName;
            if(item.longitude&&item.latitude){
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude, CONSTANTS.ALTITUDE),
                    id:item.id,
                    attributes:item,
                    //立广告牌
                    billboard :{
                        image : require("../../img/map/camera.png"),
                        show : true,
                        width : 72,
                        height : 68,
                        pixelOffset:new Cesium.Cartesian2(0, 0),
                        heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });

    }
}
export default CameraLayer;
